import { createContext } from 'react'

const AppNotificationsContext = createContext()

export default AppNotificationsContext
